import React from 'react';
import { useNavigate } from 'react-router-dom';

import '../styles/HomePage.css'

import logo from '../utils/sanfer-mx.png'
import nuevaReservacionIcon from '../utils/nueva-reserva.png'
import completarReservacionIcon from '../utils/completar-reserva.png'
import consultarReservacionIcon from '../utils/buscar-reserva.png'

const HomePage = () => {

  const navigate = useNavigate();

  return (
    <div className="homepage-container">
      <header className="header">
        <img src={logo} alt="Sanfer Logo" className="logo" />
        <h1>Sistema de reservaciones de almacén</h1>
        <p>Selecciona una opción para continuar</p>
      </header>
      <div className="buttons-grid">
        <div className="button-container" onClick={() => navigate('/nueva-reservacion')}>
          <img src={nuevaReservacionIcon} alt="Nueva Reservación" className="button-icon" />
          <button className="action-button"></button>
        </div>
        <div className="button-container" onClick={() => navigate('/completar-reservacion')}>
          <img src={completarReservacionIcon} alt="Completar Reservación" className="button-icon" />
          <button className="action-button"></button>
        </div>
        <div className="button-container" onClick={() => navigate('/consultar-reservacion')}>
          <img src={consultarReservacionIcon} alt="Consultar Reservación" className="button-icon" />
          <button className="action-button"></button>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
